import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { USER_GROUP_ROLE_BINDING_DELETE } from "./gql";

export const useBulkUserGroupRoleDelete = createBulkMutationHook(USER_GROUP_ROLE_BINDING_DELETE);

const useUserGroupRoleDelete = createDefaultMutationHook(USER_GROUP_ROLE_BINDING_DELETE);
export default useUserGroupRoleDelete;
